module.exports = __webpack_public_path__ + "img/Inventory.6f092728.png";